<ng-container *ngrxLet="coursePaymentsStatuses$; let coursePaymentsStatuses">
    <ng-container *ngIf="coursePaymentsStatuses">
        <div class="form-group mb-20">
            <div *ngIf="coursePaymentsStatuses.isLoading" class="panel">
                <div class="panel-body block-loading"></div>
            </div>

            <ng-container *ngIf="coursePaymentsStatuses.isEmpty">
                <div class="alert alert-warning alert-sm mb-10">
                    {{ "no_active_payment_methods" | translate }}
                </div>
                <a class="dashed" [href]="'/edu/courses/details/' + courseId + '/settings'" target="_blank">
                    {{ "enable" | translate }}
                </a>
            </ng-container>

            <ng-container *ngIf="coursePaymentsStatuses.isNotEmpty">
                <div *ngFor="let paymentElement of paymentElements; let i = index; trackBy: trackByPaymentElementIndex">
                    <sp-control-handle
                        *ngIf="courseTariffId ? paymentElement.isActive : true"
                        [controlHandleCheckbox]="!courseTariffId"
                        [controlHandleCheckboxChecked]="paymentElement.isActive"
                        [controlHandleSubTextDanger]="!paymentElement?.amount"
                        [controlHandleIcon]="getPaymentElementIcon(paymentElement?.type)"
                        [controlHandleMainText]="getPaymentElementLabel(paymentElement?.type) | translate"
                        [controlHandleSubText]="getPaymentElementSubText(paymentElement)"
                        (toggleCheckBoxEvent)="changePaymentElementIsActive(i)"
                    ></sp-control-handle>
                </div>
            </ng-container>

            <div *ngIf="coursePaymentsStatuses.isFailure" class="alert alert-danger">
                {{ "unknown_error" | translate }}
            </div>
        </div>
    </ng-container>
</ng-container>
